import React, { useState } from "react";
import { Button, FormControl, TextField, Box, Typography, Paper, CircularProgress, Backdrop } from '@mui/material';
import { useNavigate } from "react-router-dom";
import ApiConfig from '../../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';

const LoadingScreen = ({ open }) => (
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <CircularProgress color="inherit" />
    </Backdrop>
);

function CreateStatusCode(props) {
  const [loading, setLoading] = useState(false);
  const [status_code, setStatusCode] = useState({
    Id: "",
    StatusCode: "",
    Description: "",
    UpdatedBy: "",
    CreatedBy: "",
  });
  const { keycloak } = useKeycloak();
  const a = new ApiConfig(keycloak)
  const apiConfig = a.api()
  const navigate = useNavigate();

//   const initRetrieve = () => {
//     Promise.all([
//         apiConfig.fetchRobotData(0),
//         apiConfig.fetchRobotSite(id)
//     ]).then(results => {
//         console.log(results[0])
//         setRobots(results[0].RobotResponse)
//         console.log(results[1])
//         setSite(results[1].RobotResponse)
//     }).catch(error => {
//         console.error(error);
//     });
//   }

//   useEffect(() => {
//     initRetrieve()
//   }, []);

  const handleCreate = () => {
    // console.log(software)
    setLoading(true);
    Promise.all([
        apiConfig.createStatusCode(status_code),
    ]).then(results => {
        // setTimeout(() => {
        console.log(results[0])
        setLoading(false);
        navigate("/managements/status_code_management");
        // }, 5000);
    }).catch(error => {
        console.error(error);
        alert(error)
        setLoading(false)
    });
  }

  const handleStatusCodeChanges = (e) => {
    const { name, value } = e.target;
    setStatusCode(prevState => ({ ...prevState, [name]: value }));
    setStatusCode(prevState => ({ ...prevState, "UpdatedBy": keycloak.tokenParsed?.preferred_username || "system" }));
    setStatusCode(prevState => ({ ...prevState, "CreatedBy": keycloak.tokenParsed?.preferred_username || "system" }));
  };

  const handleCancel = () => {
    setLoading(false)
    setStatusCode({})
    navigate("/managements/status_code_management");
  }

  return (
    <Box p={2}>
    <LoadingScreen open={loading} />
      <Typography variant="h4">Create New Status Code</Typography>
      <Paper elevation={3} sx={{ p: 2, mt: 2 }}>
        <form onSubmit={(e) => { e.preventDefault(); handleCreate(); }}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
                fullWidth
                label="Status Code"
                name="StatusCode"
                variant="outlined"
                value={status_code.StatusCode}
                InputLabelProps={{ shrink: true }}
                onChange={handleStatusCodeChanges}
                sx={{ mb: 2 }}
            />
            <TextField
                fullWidth
                label="Description"
                name="Description"
                variant="outlined"
                value={status_code.Description}
                InputLabelProps={{ shrink: true }}
                onChange={handleStatusCodeChanges}
                sx={{ mb: 2 }}
            />
          </FormControl>
          <Button variant="contained" color="primary" type="submit">
            Create
          </Button>
          <Button variant="contained" color="primary" type="button" onClick={handleCancel}>
            Cancel
          </Button>
        </form>
      </Paper>
    </Box>
  );
}

export default CreateStatusCode;
